import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import ModalAdUnit from '../AdUnit/Modal/Modal';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

export interface Props {}

const GlobalModalPlacement: React.FC<Props> = () => {
  const { isLoggedIn } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);

  // Explicitly turned off by URL param
  let pageUrl;
  if (typeof window !== 'undefined') {
    pageUrl = new URL(window.location.toString());
    if (pageUrl.searchParams.get('dealer_off') !== null) {
      return null;
    }
  }

  if (isMobile) {
    return null;
  }

  // User
  if (isLoggedIn) {
    return <ModalAdUnit realEstateId="97b2237b-f469-4a05-929e-00306ae7da8a" />;
  }

  // Anon
  return null;
};
GlobalModalPlacement.displayName = 'GlobalModalPlacement';

export default GlobalModalPlacement;
